import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Link,
  MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Webservice/Webservice";
import { toast } from "react-toastify";

function Signup() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    gender: "",
    type: "email",
    customerType: "business",
  });
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    if (!formData.name || !formData.email || !formData.password || !formData.gender) {
      toast.error("Please fill in all required fields");
      return;
    }

    const payload = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      gender: formData.gender,
      type: formData.type,
      customerType: formData.customerType,
    };

    try {
      const response = await postData("customer/register", payload);
      if (response && !response.error) {
        setShowOtp(true);
        toast.success("Registration successful. Please verify OTP.");
      }
    } catch (error) {
      console.error("Signup error:", error);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      const response = await postData("customer/verify-otp", {
        email: formData.email,
        code: otp,
      });

      if (response && !response.error) {
        toast.success("OTP Verified Successfully");
        navigate("/signin");
      }
    } catch (error) {
      console.error("OTP Verification error:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Left Section - Signup Form */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          maxWidth: 550,
        }}
      >
        <Box sx={{ maxWidth: 350, width: "100%", mx: "auto" }}>
          <Box
            component="img"
            src="/img/tvfml.png"
            alt="TVFM Logo"
            sx={{
              height: 45,
              width: "auto",
              mb: 2,
            }}
          />

          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", mb: 1, color: "#000" }}
          >
            {showOtp ? "Verify OTP" : "Sign up now"}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", mb: 2 }}>
            {showOtp ? "Enter the 6-digit code sent to your email" : "Create a free account"}
          </Typography>

          {!showOtp ? (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
              />

              {/* Gender */}
              <TextField
                select
                fullWidth
                label="Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
              >
                <MenuItem value="male">Male</MenuItem>
                <MenuItem value="female">Female</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </TextField>

              {/* Email */}
              <TextField
                fullWidth
                label="Email address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
              />

              {/* Password */}
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
              />

              {/* Confirm Password */}
              <TextField
                fullWidth
                label="Confirm password"
                name="confirmPassword"
                type="password"
                value={formData.confirmPassword}
                onChange={handleChange}
                variant="outlined"
                margin="normal"
                required
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.2,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "1rem",
                  backgroundColor: "#000",
                  "&:hover": { backgroundColor: "#333" },
                }}
              >
                Sign up
              </Button>
            </Box>
          ) : (
            <Box>
              <TextField
                fullWidth
                label="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                variant="outlined"
                margin="normal"
                required
                inputProps={{ maxLength: 6 }}
              />
              <Button
                fullWidth
                variant="contained"
                onClick={handleVerifyOtp}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1.2,
                  borderRadius: "8px",
                  textTransform: "none",
                  fontSize: "1rem",
                  backgroundColor: "#000",
                  "&:hover": { backgroundColor: "#333" },
                }}
              >
                Verify
              </Button>
            </Box>
          )}

          <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Already have an account?{" "}
            <Link href="/signin" underline="hover">
              Sign in
            </Link>
          </Typography>
        </Box>
      </Box>

      {/* Right Section - Image */}
      <Box
        sx={{
          flex: 1,
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          position: "relative",
          overflow: "hidden",

        }}
      >
        <Box
          component="img"
          src="img/r3.jpg"
          alt="Signup Visual"
          sx={{
            width: "100%",
            height: "100vh",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
    </Box>
  );
}

export default Signup;
